import { notifications } from '@mantine/notifications';
import { sendTestMessage } from '../../apiClient';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useSendTestMessage = () => {
    const mutation = useMutation({
        mutationKey: 'send_test_message',
        mutationFn: (model) => sendTestMessage(model),
        onSuccess: (data) => {
            notifications.show({
                title: 'Success',
                message: 'Successfully sent test message.',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return mutation;
};
export default useSendTestMessage;
